document.addEventListener('DOMContentLoaded', () => {
  const wrapper = document.getElementById('custom-question-wrapper');
  const form = document.querySelector('form[data-type="add-to-cart-form"]');
  if (!form || !wrapper) return;

  const steps = [
    {
      id: 'conformation',
      type: 'radio',
      title: 'Is over 18 years old\nIs using this product for nasal inflammation associated with allergies\nIs not allergic to steroids or any other ingredients listed in the patient leaflet.\nIs not pregnant or breastfeeding\nIs not suffering with a nasal infection; sinus problems; recent surgery; nasal injury; ulcers in the nose\nIs not taking any other corticosteroid medicines such as asthma inhalers, tablets, injections, eye/nose drops, creams or ointments.\nAgrees not to use this product for longer than 3 months without seeking GP advice.',
      options: ['Yes', 'No'],
      required: true,
      warning: 'Unfortunately unless the above criteria are met, this product would not be suitable for use. Please book to see your GP or contact our healthcare team to discuss. For more services in your area, please visit NHS Online.'
    },
  ];

  let answers = {};
  let drawer = null;
  let content = null;
  let isCancelled = false; // Unified cancellation state

  function buildDrawer() {
    drawer = document.createElement('div');
    drawer.className = 'drawer';
    drawer.id = 'cq-drawer';

    drawer.innerHTML = `
      <div class="cart-drawer__overlay backdrop"></div>
      <div class="drawer__inner">
        <div class="drawer__header">
          <div class="drawer__title-wrapper">
            <h2 class="drawer__heading">Questionnaire</h2>
            <p class="drawer__subheading">
              Just a few quick questions from our pharmacist before you check out, to ensure this medicine is safe for you.
            </p>
          </div>
          <button class="drawer__close" id="close" aria-label="Close">
            <span class="svg-wrapper">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-close" viewBox="0 0 18 17">
                <path fill="currentColor" d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"></path>
              </svg>
            </span>
          </button>
        </div>
        <div id="content" class="drawer__contents panel-content"></div>
      </div>
    `;

    document.body.appendChild(drawer);
    content = drawer.querySelector('#content');

    drawer.querySelector('#close').addEventListener('click', closeDrawer);
    drawer.querySelector('.backdrop').addEventListener('click', closeDrawer);
  }

  function openDrawer() {
    if (!drawer) buildDrawer();
    content.innerHTML = '';
    answers = {};
    isCancelled = false;
    openStep(0);

    drawer.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    if (drawer) {
      drawer.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  document.querySelector('button[name="add"][type="submit"]').addEventListener('click', e => {
    e.preventDefault();
    if (!document.querySelector('#cq-drawer')) {
      openDrawer();
    } else if (!drawer.classList.contains('active')) {
      openDrawer();
    }
  });

  function openStep(index) {
    if (index >= steps.length || isCancelled) return finalize();

    const step = steps[index];

    // Prevent re-rendering if the step already exists
    if (document.getElementById(`step-div-${step.id}`)) {
      return;
    }

    const stepDiv = document.createElement('div');
    stepDiv.className = 'cq-step';
    stepDiv.id = `step-div-${step.id}`;
    stepDiv.innerHTML = `
      <label for="input-${step.id}"><strong>${step.title}</strong></label>
      ${buildInputHTML(step)}
      <div class="error" id="err-${step.id}" aria-live="polite"></div>
      <div class="invalid" id="invld-${step.id}" aria-live="polite"></div>
    `;
    content.appendChild(stepDiv);
    stepDiv.scrollIntoView({ behavior: 'smooth', block: 'start' });

    setTimeout(() => {
      const selector = `input[name="${step.id}"]`;
      const elements = drawer.querySelectorAll(selector);
      elements.forEach(el => {
        el.addEventListener('change', () => handleInput(step, index));
      });
    }, 0);
  }

  function buildInputHTML(step) {
    return step.options.map(opt => `
      <label class="cq-radio">
        <input type="radio" name="${step.id}" value="${opt}"> ${opt}
      </label>
    `).join('<br>');
  }

  function handleInput(step, index) {
    const err = document.getElementById(`err-${step.id}`);
    const invld = document.getElementById(`invld-${step.id}`);
    err.textContent = '';
    invld.textContent = '';

    let val = '';
    const checked = document.querySelector(`input[name="${step.id}"]:checked`);
    val = checked ? checked.value : '';

    if (step.required && !val) {
      err.textContent = 'This field is required.';
      return;
    }

    answers[step.id] = val;

    // Show warning and handle invalidation based on specific conditions
    if (step.id === 'conformation' && val === 'No') {
      err.innerHTML = `⚠️ ${step.warning}`;
      invld.innerHTML = `⚠️ Your selection has invalidated the purchase process. Please review the information above.`;
      isCancelled = true; // Set cancellation flag
      return finalize(); // Prevent proceeding further
    }

    // Allow the flow to continue if no invalid responses
    openStep(index + 1);
  }

  function finalize() {
    if (isCancelled) {
      // Only show invalidation message if the process was cancelled
      const invld = document.getElementById('invld-conformation');
      if (invld) {
        invld.innerHTML = '<p class="confirm-msg">⚠️ Your selection has invalidated the purchase process. Please try again.</p>';
      }
      return;
    }

    // Remove existing hidden inputs
    Object.keys(answers).forEach(key => {
      const existing = form.querySelector(`input[name="properties[${key}]"]`);
      if (existing) existing.remove();
    });

    const fieldNames = {
      conformation: 'Confirmation of criteria agreement'
    };

    Object.entries(answers).forEach(([key, val]) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = `properties[${fieldNames[key] || key}]`;
      input.value = val;
      form.appendChild(input);
    });

    content.innerHTML = '<p class="confirm-msg">Thank you — adding to cart...</p>';

    setTimeout(() => {
      closeDrawer();
      form.submit();
    }, 800);
  }
});
